// Module
var code = `<template>
  <require from="./processed-vouchers-widget.scss"></require>

  <div class="processed-vouchers-widget">
    <style if.bind="config.hidePaging">
      .ag-paging-panel {
        display: none !important;
      }
    </style>

    <!-- beautify ignore:start -->
    <style>
      .ag-header,
      .ag-cell {
        font-size: \${fontSize}px !important;
      }

      .ag-cell {
        line-height: \${rowHeight}px !important;
      }
    </style>
    <!-- beautify ignore:end -->

    <ag-grid-aurelia if.bind="!error" theme-selector grid-options.bind="gridOptions" style.bind="gridStyle">

      <ag-grid-column header-name="Date" field="lastDetail.lastTransactionDate" editable="false" sort="desc" filter="agDateColumnFilter" filter-params.bind="getDateFilterParams()" type="date"></ag-grid-column>

      <ag-grid-column header-name="Voucher NR" field="voucherNr" cell-width.bind="200" editable="false"></ag-grid-column>

      <ag-grid-column header-name="ISIN" field="lastDetail.isin" cell-width.bind="200" editable="false"></ag-grid-column>

      <ag-grid-column header-name="Name" field="lastDetail.name" cell-width.bind="200" editable="false"></ag-grid-column>

      <ag-grid-column header-name="Action" field="lastDetail.lastActionType" editable="false" value-formatter.bind="actionTypeValueFormatter" filter="agSetColumnFilter" filter-params.bind="{valueFormatter: actionTypeValueFormatter}"></ag-grid-column>

      <ag-grid-column header-name="Quantity" field="quantity" type="amount" editable="false"></ag-grid-column>

      <ag-grid-column header-name="Amount" field="amount" type="amountTwoDec" editable="false"></ag-grid-column>

      <ag-grid-column header-name="Dividend" field="dividend" type="amountTwoDec" editable="false"></ag-grid-column>

      <ag-grid-column header-name="Interest" field="interests" type="amountTwoDec" editable="false"></ag-grid-column>

      <ag-grid-column header-name="Profit" field="profit" type="amountTwoDec" editable="false"></ag-grid-column>

      <ag-loading-overlay-template>
        <mdc-circular-progress></mdc-circular-progress>
      </ag-loading-overlay-template>
    </ag-grid-aurelia>

    <message if.bind="error" class="processed-vouchers-widget__error" icon="error" colour="mdc-theme--error">
      \${error.message}
    </message>
  </div>
</template>
`;
// Exports
export default code;